# see: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe#attr-sandbox
module.exports = 'allow-scripts allow-forms allow-popups allow-same-origin allow-popups-to-escape-sandbox allow-modals allow-presentation'
